<template lang="pug">
  v-app-bar.z-index-1(
    :color="color"
    app
    flat
    height="60"
    :dark="isDark"
  )
    v-container
      v-row(class="align-center" no-gutters)
        v-btn.d-sm-none.mr-1(
          v-if="isAuthenticated"
          icon
          @click="$store.dispatch('SET_DRAWER', true)"
        ): v-icon mdi-menu

        v-col(v-if="!isAuthenticated" cols=3 sm=8)
          router-link(to="/")
            v-img.my-2.ml-md-2(
              :src="require(`@/assets/logo${logoPrefix}.svg?inline`)"
              height="40"
              contain
              position="left center"
            )
        //- TODO: Убрать 'Тестовый регион' когда у всех пользователей в базе будут регионы.
        v-chip.d-none.d-sm-block.caption(v-else) {{ userRegion.name || 'Тестовый регион' }}

        v-spacer
        template(
          v-if="!$user.data"
        )
          v-btn(
            to="/sign-in"
            depressed
            rounded
            text
          )
            v-icon(left) mdi-account
            | Вход в систему

        notification-badge(v-if="$user.isAuthenticated")

        v-menu(
          v-if="$user.data"
          transition="slide-y-reverse-transition"
          bottom left offset-y
        )
          template(v-slot:activator="{ on, attrs, value }")
            v-btn(
              v-on="on"
              class="pl-0"
              depressed rounded text
            )
              v-avatar(color="white" size="34" class="mr-2")
                span(class="primary--text") {{ firstLetterName }}
              span.hidden-sm-and-down
                | {{ userData.info.surname }}
                | {{ userData.info.first_name }}
                | {{ userData.info.patronymic }}
              v-icon(right) {{ value ? 'mdi-chevron-down' : 'mdi-chevron-down' }}
          v-list(dense).px-1
            permissions-wrapper.pt-1(
              v-slot:default
              :roles="[$conf.ROLES.teacher]"
            )
              v-list-item Ваш номер {{ userData.number }}
            v-list-item(:to="{ name: 'UserSettings' }")
              v-list-item-title
                v-icon(left) mdi-cogs
                | Настройки
            v-btn(
              v-if="$user.isListener"
              @click="wantToTeach" color="primary" outlined block
            )
              v-icon(left ) mdi-account
              | Хочу преподавать
            v-divider(class="mx-4 my-1")
            v-list-item(@click="logout" :disabled="loadings.logout")
              v-list-item-title
                v-icon(left) mdi-account-cancel
                | Выйти

</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import NotificationBadge from '@/components/Layout/NotifcationBadge.vue';
import SignInForm from '@/modules/Auth/components/SignInForm.vue';

export default {
  name: 'TheAppBar',
  components: {
    SignInForm,
    NotificationBadge,
  },
  props: {
    drawer: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    showSignInForm: false,
    loadings: {
      logout: false,
    },
  }),
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      userData: 'auth/userData',
      userRegion: 'auth/userRegion',
      darkTheme: 'darkTheme',
    }),
    isHomepage() {
      return this.$route.path === '/';
    },
    isDark() {
      return !this.isAuthenticated;
    },
    color() {
      if (!this.isAuthenticated && this.isHomepage) {
        return '#7a6677';
      }
      if (this.isAuthenticated) {
        return '';
      }
      return 'secondary';
    },
    logoPrefix() {
      if (this.$vuetify.breakpoint.xs) return '';
      return this.isDark ? '-white' : '-dark';
    },
    firstLetterName() {
      const { info } = this.userData;
      if (info && info.patronymic) return info.patronymic[0];
      return this.userData.name[0];
    },
  },
  methods: {
    ...mapActions({ LOGOUT: 'auth/LOGOUT' }),
    async wantToTeach() {
      this.$modals.show('confirm-controller', {
        title: 'Действительно ли вы хотите изменить свою роль на учителя?',
        message: 'После изменения роли обратное изменение будет невозможно',
        dialogProps: {
          width: 800,
        },
        method: async () => {
          await this.$api.auth.transformToTeacher();
          await this.$user.syncUser();
          this.$modals.close();
        },
      });
    },
    async logout() {
      this.$loader.start();
      await this.LOGOUT();
      if (this.$route.path !== '/') this.$router.push({ name: 'Home' });
      this.loadings.logout = false;
      this.$loader.stop();
    },
  },
};
</script>
